import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import styles from '../../TransferPage.module.scss';
import debitCard from 'assets/images/debit-card.svg';
import checkBlc from 'assets/images/check-blc.svg';
import Validator from '../../../common/common-functions';
import { transcationActions, commonActions } from '../../../../stores/_actions';
import { Button } from 'semantic-ui-react';

function Payment(props) {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const history = useHistory();
  const location = useLocation();
  let errorMsgLastName;
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
      Refno: '',
      FromDate: '01/Jan/2000',
      ToDate: '01/Jan/2050',
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    FileType: null,
    Langcode: null,
  };
  const [paymentPayload, setPaymentPayload] = useState({
    PayMode: '',
    PurposeCode: '',
    SourceCode: '',
    PayBankCode: '',
    paymentRefno: '',
  });

  const purposeSourcePayload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      ServNo: location.state?.items?.ServNO,
      CustomerCode: profile?.CustomerCode,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    FileType: null,
    Langcode: null,
  };

  const [buttonActive, setButtonActive] = useState(false);
  const purposelist = useSelector((state) => state.purpose.data);
  const sourcelist = useSelector((state) => state.source.data);
  const drawingBankList = useSelector((state) => state.getDrawingBank.data);
  const paymentModeList = useSelector((state) => state.paymentMode.data);
  const [beneficiary, setStyle] = useState(false);
  const [source, setClass] = useState(false);
  const [drawing, setDrawing] = useState(false);
  const [inc, setInc] = useState('Purpose of Transaction');
  const [ins, setIns] = useState('Source of Money');
  const [drawBank, setDrawBank] = useState('Drawing Bank');
  const [paymentRefno, setPaymentRefNo] = useState('');

  const dispatch = useDispatch();

  useEffect(() => {
    if (paymentModeList && paymentModeList.length > 0) {
      setPaymentPayload((paymentPayload) => ({ ...paymentPayload, PayMode: '' }));
      history.push({ pathname: '/transfer', state: { ...location.state, paymentPayload } });
    }
  }, [paymentModeList]);

  useEffect(() => {
    dispatch(transcationActions.paymentMode(payload));
    dispatch(transcationActions.getDrawingBank());
    dispatch(commonActions.purpose(purposeSourcePayload));
    dispatch(commonActions.source(purposeSourcePayload));
    // setButtonActive(true);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPaymentRefNo((paymentRefno) => ({ ...paymentRefno, [name]: value }));
    const checkNumber = Validator.alphanumberic(value);
    if (!checkNumber) {
      errorMsgLastName = 'Please enter Alphanumeric only';
      // setButtonActive(true);
      setPaymentRefNo((paymentRefno) => ({ ...paymentRefno, errorMsgLastName: errorMsgLastName }));
    }
    paymentPayload['paymentRefno'] = paymentRefno.paymentRefNo;
    setPaymentPayload((paymentPayload) => ({ ...paymentPayload, paymentRefno: value }));
  };

  useEffect(() => {
    if (paymentPayload['PayMode'] === '') {
      setButtonActive(true);
    } else {
      if (paymentPayload['PayMode'].Type !== 'A') {
        if (paymentPayload['PurposeCode'] === '' || paymentPayload['SourceCode'] === '') {
          setButtonActive(true);
        } else {
          setButtonActive(false);
        }
      } else {
        if (
          paymentPayload['PurposeCode'] === '' ||
          paymentPayload['SourceCode'] === '' ||
          paymentPayload['PayBankCode'] === '' ||
          paymentPayload['paymentRefno'] === '' ||
          paymentPayload['PayMode'] === ''
        ) {
          setButtonActive(true);
        } else {
          setButtonActive(false);
        }
      }
    }
    history.push({ pathname: '/transfer', state: { ...location.state, paymentPayload } });
  }, [paymentPayload]);

  const purposes = (items) => {
    setStyle(!beneficiary);
    setInc((inc) => (inc = items.Description));
    paymentPayload['PurposeCode'] = items.ID;
    setPaymentPayload((paymentPayload) => ({ ...paymentPayload, PurposeCode: items.ID }));
    // setButtonActive(false);
  };

  const sources = (items) => {
    setClass(!source);
    setIns((ins) => (ins = items.Description));
    paymentPayload['SourceCode'] = items.ID;
    setPaymentPayload((paymentPayload) => ({ ...paymentPayload, SourceCode: items.ID }));
  };

  const drawingBank = (items) => {
    setDrawing(!drawing);
    setDrawBank((drawBank) => (drawBank = items.PayBankName));
    paymentPayload['PayBankCode'] = items.PayBankCode;
    setPaymentPayload((paymentPayload) => ({ ...paymentPayload, PayBankCode: items.PayBankCode }));
  };

  const selectPayMode = (items) => {
    paymentPayload['PayMode'] = items;
    setPaymentPayload((paymentPayload) => ({ ...paymentPayload, PayMode: items }));
  };

  const currencyItems =
    purposelist &&
    purposelist.map((items) => (
      <a key={items.ID} id={items.ID} data={JSON.stringify(items)} onClick={(e) => purposes(items)}>
        {items.Description}
      </a>
    ));

  const sourceItems =
    sourcelist &&
    sourcelist.map((items) => (
      <a key={items.ID} id={items.ID} data={JSON.stringify(items)} onClick={(e) => sources(items)}>
        {items.Description}
      </a>
    ));

  const drawingBankItems =
    drawingBankList &&
    drawingBankList.map((items) => (
      <a key={items.PayBankName} id={items.PayBankCode} data={JSON.stringify(items.PayBankName)} onClick={(e) => drawingBank(items)}>
        {items.PayBankName}
      </a>
    ));

  const modeList =
    paymentModeList &&
    paymentModeList.map((items) => {
      return (
        <div className={styles.payment__item} key={items.ID}>
          <div className={styles.payment__radio}>
            <input type="radio" name="code" onClick={(e) => selectPayMode(items)} />
            <label>
              <span>
                {/* <img src={items.BaseURL == '' ? checkBlc : items.BaseURL} alt="" /> */}
                <img src={checkBlc} alt="" />
              </span>
            </label>
          </div>
          {items.Type == 'P' && (
            // <Link to={items.BaseURL} target="_blank">
            //   {' '}
            <img className={styles.payment__paymode + ' ' + styles.middle} src={items.ImagePath} alt="" />
            // </Link>
          )}
          {items.Type == 'A' && (
            <img
              className={styles.payment__paymode + ' ' + styles.ac_transfer}
              src={items.Type == 'C' ? items.ImagePath : items.Type == 'A' ? items.ImagePath : debitCard}
              alt=""
            />
          )}
          {items.Type == 'C' && (
            <img
              className={styles.payment__paymode}
              src={items.Type == 'C' ? items.ImagePath : items.Type == 'A' ? items.ImagePath : debitCard}
              alt=""
            />
          )}
          {/* {items.BaseURL == '' ? <p>{items.Description}</p> : ''} */}
          <p>{items.Description}</p>
        </div>
      );
    });
  const backButton = () => {
    const menu = {
      beneficiary: false,
      amount: true,
      payment: false,
      confirm: false,
      transfer: false,
      print: false,
    };
    const menuValue = {
      ...location.state,
      menu,
      buttonActive,
    };
    history.push({ pathname: '/transfer', state: menuValue });
  };

  const valid = useSelector((state) => {});

  const forwordButton = () => {
    const menu = {
      beneficiary: false,
      amount: false,
      payment: false,
      confirm: true,
      transfer: false,
      print: false,
    };
    // if (location.state.paymentPayload) {
    //   if (location.state.paymentPayload.PurposeCode != null && location.state.paymentPayload.SourceCode != null) {
    //     setButtonActive(false);
    //   }
    // } else {
    //   setButtonActive(true);
    // }

    // setMenu((menu) => (menu, (menu.confirm = true), (menu.payment = false)));
    const menuValue = {
      ...location.state,
      menu,
      buttonActive,
    };
    history.push({ pathname: '/transfer', state: menuValue });
  };

  return (
    // <div className={styles.payment+ ' ' + `${props.display == undefined ? `${styles.hidden}` : props.display}`}>
    <>
      <div className={styles.payment}>
        {modeList ? modeList : <div className={styles.spinner}></div>}

        {paymentPayload.PayMode.Type == 'A' ? (
          <>
            <div className={styles.payment__item2}>
              <div className={styles.payment__selecBox}>
                <div className={styles.dropdown + ' ' + styles.dropdown2}>
                  <button type="button" onClick={() => setDrawing(!drawing)}>
                    {drawBank}
                  </button>
                  <div className={styles.dropdown__droppop + ` ` + `${drawing ? styles.show : styles.hide}`}>{drawingBankItems}</div>
                </div>
              </div>
            </div>

            <div className={styles.payment__item2}>
              <div className={styles.payment__selecBox}>
                <input
                  type="text"
                  placeholder="Payment Ref No"
                  maxLength="16"
                  name="paymentRefNo"
                  value={paymentRefno.paymentRefNo}
                  onChange={handleChange}
                  style={{ fontWeight: 'bold', color: 'black', fontFamily: 'montserratregular' }}
                />
                <div className={styles.LoginPage__error}>{paymentRefno.errorMsgLastName}</div>
              </div>
            </div>
          </>
        ) : (
          ''
        )}

        <div className={styles.payment__item2}>
          <div className={styles.payment__selecBox}>
            <div className={styles.dropdown + ' ' + styles.dropdown2}>
              <button type="button" onClick={() => setStyle(!beneficiary)}>
                {inc}
              </button>
              <div className={styles.dropdown__droppop + ` ` + `${beneficiary ? styles.show : styles.hide}`}>{currencyItems}</div>
            </div>
          </div>
        </div>

        <div className={styles.payment__item2}>
          <div className={styles.payment__selecBox}>
            <div className={styles.dropdown + ' ' + styles.dropdown2}>
              <button type="button" onClick={() => setClass(!source)}>
                {ins}
              </button>
              <div className={styles.dropdown__droppop + ` ` + `${source ? styles.show : styles.hide}`}>{sourceItems}</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.pageLeft__buttonCenter}>
        <Button onClick={backButton}>previous</Button>
        <Button className={buttonActive ? 'disabled' : ''} onClick={forwordButton}>
          {' '}
          next{' '}
        </Button>
      </div>
    </>
  );
}

export { Payment };
